export const updateCampaignFormFields = [
    {
        name: 'jobId',
        label: 'Campaign Name',
        type: 'text',
        required: true,
        placeholder: 'Enter Campaign Name',
        className: 'campaignName',
        isDisabled: true, // Cannot change name during update
        rules: {
            maxLength: {
                value: 64,
                message: "Maximum 64 characters are allowed.",
            }
        },
    },
    {
        name: 'otaArtifactId',
        label: 'OTA Artifacts',
        type: 'select',
        required: true,
        placeholder: 'Select OTA Artifact',
        className: 'otaArtifacts',
        options: [],
        isDisabled: true,
    },
    {
        name: 'status',
        label: 'Campaign Status',
        type: 'select',
        required: true,
        placeholder: 'Select Status',
        className: 'campaignStatus',
        options: [
            { value: 'COMPLETED', label: 'COMPLETED' },
            { value: 'CANCELLED', label: 'CANCELLED' }
        ],
    },
    {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        rows: '3',
        required: false,
        placeholder: 'Enter Description',
        className: 'campaignDescription',
        isDisabled: true,
        rules: {
            maxLength: {
                value: 255,
                message: "Maximum 255 characters are allowed.",
            }
        }
    }
];
